<router-outlet></router-outlet>
<lib-cookie-consent-mount></lib-cookie-consent-mount>
@if (devOverlay; as overlay) {
  <ng-container *ngComponentOutlet="overlay" />
}
